<template>
	<v-container>
		<Pendentes />
		<Aprovadas />
		<Reprovadas />
		<Inativas />
		<Publicacao />
		<v-row>
			<v-col cols=12>
				<v-card :loading="loading">
					<v-card-title>
						<h1>Textos </h1><v-spacer></v-spacer> <v-chip color="primary">{{publicacoes.total}}</v-chip>
					</v-card-title>
					<v-card-text>
						<v-container>
							<v-row>
								<v-col cols=12 class="col-sm-6 col-md-3">
									<v-card>
										<v-card-title>
											<h5>Aprovados</h5><v-spacer></v-spacer> <v-chip color="primary" @click.stop="abrirDetalhes('A')">{{publicacoes.aprovados}}</v-chip>
										</v-card-title>
									</v-card>
								</v-col>
								<v-col cols=12 class="col-sm-6 col-md-3">
									<v-card >
										<v-card-title>
											<h5>Pendentes</h5><v-spacer></v-spacer> <v-chip color="primary" @click.stop="abrirDetalhes('P')">{{publicacoes.pendentes}}</v-chip>
										</v-card-title>
									</v-card>
								</v-col>
								<v-col cols=12 class="col-sm-6 col-md-3">
									<v-card >
										<v-card-title>
											<h5>Reprovados</h5><v-spacer></v-spacer> <v-chip color="primary" @click.stop="abrirDetalhes('R')">{{publicacoes.reprovados}}</v-chip>
										</v-card-title>
									</v-card>
								</v-col>
								<v-col cols=12 class="col-sm-6 col-md-3">
									<v-card >
										<v-card-title>
											<h5>Inativos</h5><v-spacer></v-spacer> <v-chip color="primary" @click.stop="abrirDetalhes('I')">{{publicacoes.inativos}}</v-chip>
										</v-card-title>
									</v-card>
								</v-col>
							</v-row>
						</v-container>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	
	import Pendentes from '@/components/admin/textos/Pendentes'
	import Aprovadas from '@/components/admin/textos/Aprovadas'
	import Reprovadas from '@/components/admin/textos/Reprovadas'
	import Inativas from '@/components/admin/textos/Inativas'
	import Publicacao from '@/components/admin/textos/Publicacao'
	import axios from 'axios'
	import { baseApiUrl, showSuccess } from "@/config/global"
	import Br from '@/config/barramento.js'

	export default{
		name: 'AdminTextos',
		components: { 
			Pendentes,
			Aprovadas,
			Reprovadas,
			Inativas,
			Publicacao
			},
		computed:{
			textosPendentes(){
				
				let texto = ""

				if(this.publicacoes.pendentes == 0){
					texto = 'Não há textos para aprovar'
				}else if(this.publicacoes.pendentes == 1){
					texto = 'Há 1 texto aguardando aprovação'
				}else{
					texto = 'Há ' + this.publicacoes.pendentes + ' textos aguardando aprovação'
				}

				return texto
			},
		},
		data(){
			return{
				publicacoes: {},
				itens: {},
				avisos: {},
				loading: false,
				cor: 'primary',
			}
		},

		methods:{
			buscaTextos(){
				axios.get(`${baseApiUrl}/estudos/publicacoes.php`).then(res => {

					if(res.data.codigo == "01"){

						this.publicacoes = res.data
						this.loading = false;

					}
				})
			},

			abrirDetalhes(d){	
				switch(d){
					case 'P':
					if(this.publicacoes.pendentes > 0){
						if(this.itens.pendentes){
							Br.setAbrirPublicacoesPendentes(this.itens.pendentes)
						}else{
							this.buscaDetalhes(d)
						}
					}else{
						showSuccess("Não há publicações pendentes")
					}
					break

					case 'R':
					if(this.publicacoes.reprovados){
						if(this.itens.reprovados){
							Br.setAbrirPublicacoesReprovadas(this.itens.reprovados)
						}else{
							this.buscaDetalhes(d)
						}
					}else{
						showSuccess("Não há publicações reprovadas")
					}
					break

					case 'A':
					if(this.publicacoes.aprovados){
						if(this.itens.aprovados){
							Br.setAbrirPublicacoesAprovadas(this.itens.aprovados)
						}else{
							this.buscaDetalhes(d)
						}
					}else{
						showSuccess("Não há publicações aprovadas")
					}
					break

					case 'I':
					if(this.publicacoes.inativos){
						if(this.itens.inativos){
							Br.setAbrirPublicacoesInativas(this.itens.inativos)
						}else{
							this.buscaDetalhes(d)
						}
					}else{
						showSuccess("Não há publicações inativas")
					}
					break
				}

			},

			buscaDetalhes(d){
				this.loading = true
				axios.get(`${baseApiUrl}/estudos/publicacoesPorStatus.php?status=${d}`).then(res => {

					if(res.data.codigo == "01"){

						if(d == 'A'){
							this.itens.aprovados = res.data.publicacoes
							Br.setAbrirPublicacoesAprovadas(this.itens.aprovados)
							this.loading = false
						}else if(d == 'I'){
							this.itens.inativos = res.data.publicacoes
							Br.setAbrirPublicacoesInativas(this.itens.inativos)
							this.loading = false
						}else if(d == 'P'){
							this.itens.pendentes = res.data.publicacoes
							Br.setAbrirPublicacoesPendentes(this.itens.pendentes)
							this.loading = false
						}else if(d == 'R'){
							this.itens.reprovados = res.data.publicacoes
							Br.setAbrirPublicacoesReprovadas(this.itens.reprovados)
							this.loading = false
						}

						// this.detalhe = d
						// this.detalhes_publicacoes = res.data.publicacoes
						
					}else{
						this.detalhe = "N"
					}
				})	
			},
		},

		created(){
			this.loading = true
			this.buscaTextos()
			Br.onPublicacaoReprovada(publicacao => {
					switch(publicacao.statusAtual){
					case 'I':
					this.publicacoes.inativos--
					break
					case 'A':
					this.publicacoes.aprovados--
					break
					case 'P':
					this.publicacoes.pendentes--
					break
				}

				this.publicacoes.reprovados++
				if(this.itens.reprovados){
					this.itens.reprovados.push(publicacao)
				}
			})

			Br.onPublicacaoInativada(publicacao =>{
				switch(publicacao.statusAtual){
					case 'R':
					this.publicacoes.reprovados--
					break
					case 'A':
					this.publicacoes.aprovados--
					break
					case 'P':
					this.publicacoes.pendentes--
					break
				}

				this.publicacoes.inativos++
				if(this.itens.inativos){
					this.itens.inativos.push(publicacao)
				}
			})

			Br.onPublicacaoAprovada(publicacao => {
				switch(publicacao.statusAtual){
					case 'R':
					this.publicacoes.reprovados--
					break
					case 'I':
					this.publicacoes.inativos--
					break
					case 'P':
					this.publicacoes.pendentes--
					break
				}

				this.publicacoes.aprovados++
				if(this.itens.aprovados){
					this.itens.aprovados.push(publicacao)
				}
			})

			Br.onPublicacaoAtivada(publicacao => {
				switch(publicacao.destino){
					case 'R':
						if(this.itens.reprovados){
							this.itens.reprovados.push(publicacao)
						}
					
					this.publicacoes.reprovados++
					break
					case 'A':
						if(this.itens.aprovados){
							this.itens.aprovados.push(publicacao)
						}
					
					this.publicacoes.aprovados++
					break
					case 'P':
						if(this.itens.pendentes){
							this.itens.pendentes.push(publicacao)
						}
					
					this.publicacoes.pendentes++
					break
				}

				this.publicacoes.inativos--
			})

			Br.onPublicacaoExcluida(publicacao => {
				this.publicacoes.total--
				this.publicacoes.inativos--
			})
		}
	}

</script>

<style scoped>

</style>